// Maps each "Know2Grow Recommended Formal Learning Opportunities" item shown in
// the report appendixes to its page on know2grow.com.
//
// Individual LearningBursts do not have public per-burst landing pages, so each
// burst is linked to the public bundle (or program) page that contains it.
// Mapping resolved against the live know2grow.com bundle pages on 2026-06-03.
// The four bursts with no public bundle page (Deliver Feedback on the Fly,
// Design Action and Accountability Plans, Manage Up & Out, Know Your Leadership
// Signature) point at the Leaders in Motion LearningBurst bundle for now, per
// client direction — revisit once Melissa confirms their canonical URLs.
//
// Source items live in src/data/{tim,mim,lim}Appendix.json under each module's
// `forAll` array. Keys here are matched case-insensitively with whitespace
// collapsed, so they stay in sync with those strings.

const BASE = "https://www.know2grow.com";

const URLS = {
  TIM_PROGRAM: `${BASE}/course/timinfo`,
  MIM_PROGRAM: `${BASE}/course/miminfo`,
  LIM_PROGRAM: `${BASE}/course/leaders-in-motion`,
  TIM_LB: `${BASE}/course/teams-in-motion-learningburst-bundle`,
  LIM_LB: `${BASE}/course/lim-lb-bundle`,
  PRODUCTIVITY_LB: `${BASE}/course/productivitylbbundle`,
  CULTURE_LB: `${BASE}/course/culture-in-motion-bundle`,
  DISC: `${BASE}/course/improve-team-effectiveness-with-disc`,
};

// normalized title -> destination URL
const MAP = {
  // Multi-module program options
  "multi-module program option: teams in motion program": URLS.TIM_PROGRAM,
  "multi-module program option: managers in motion program": URLS.MIM_PROGRAM,
  "multi-module program option: leaders in motion program": URLS.LIM_PROGRAM,

  // Teams in Motion LearningBurst Bundle
  "learningburst: decision-making in teams: make decisions that stick": URLS.TIM_LB,
  "learningburst: combat cognitive bias in decision-making": URLS.TIM_LB,
  "learningburst: constructive conversations: get the best thinking on the table": URLS.TIM_LB,
  "learningburst: communicate up & out: strategically manage all stakeholders": URLS.TIM_LB,

  // Leaders in Motion LearningBurst Bundle
  "learningburst: coach for growth": URLS.LIM_LB,
  "learningburst: delegate to develop": URLS.LIM_LB,
  "learningburst: create a culture of accountability": URLS.LIM_LB,
  "learningburst: have difficult conversations with clarity and care": URLS.LIM_LB,
  "learningburst: be an influencer at work": URLS.LIM_LB,
  // No public bundle page found — fall back to LIM LB bundle (client direction 2026-06-03)
  "learningburst: deliver feedback on the fly": URLS.LIM_LB,
  "learningburst: design action and accountability plans": URLS.LIM_LB,
  "learningburst: manage up & out": URLS.LIM_LB,
  "learningburst: know your leadership signature": URLS.LIM_LB,

  // Productivity in Motion LearningBurst Bundle
  "learningburst: be productive at work: prioritize where you spend your time": URLS.PRODUCTIVITY_LB,
  "learningburst: improve your emotional intelligence for a greater impact at work": URLS.PRODUCTIVITY_LB,
  "learningburst: present so people will listen": URLS.PRODUCTIVITY_LB,
  "learningburst: how to receive feedback well: use a growth mindset": URLS.PRODUCTIVITY_LB,

  // Culture in Motion LearningBurst Bundle
  "learningburst: radical candor in performance conversations": URLS.CULTURE_LB,
  "learningburst: work inclusively so all are heard": URLS.CULTURE_LB,
  "learningburst: work inclusively to ensure all are heard": URLS.CULTURE_LB,

  // DISC (own public page)
  "learningburst: increase your impact with disc": URLS.DISC,
};

const normalize = (s) => String(s || "").toLowerCase().replace(/\s+/g, " ").trim();

/** Return the know2grow.com URL for a learning-opportunity item, or null. */
export const learningUrl = (title) => MAP[normalize(title)] || null;
